import  { useState } from 'react';
import Measurement from './components/measurement';
import LangLat from './components/LangLat';
import InclusionExclusion from './components/InclusionExclusion';
import Header               from '../../components/header';
import { useUnsavedChangesWarning } from '../../hooks/useNavigationBlocker';
import api from '../../services/axios';
import { toast } from 'react-hot-toast';


const MasterConfiguration = () => {
  const [activeTab, setActiveTab] = useState('measurement');
  const [isDirty, setIsDirty] = useState(false);
  const [syncingEngineStates, setSyncingEngineStates] = useState(false);
  const [syncingStationNames, setSyncingStationNames] = useState(false);

  useUnsavedChangesWarning(isDirty);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'measurement':
        return <Measurement />;
      case 'longlat':
        return (
          <LangLat />
        );
      case 'inclusion':
        return (
          <InclusionExclusion setIsDirty={setIsDirty} isDirty={isDirty}/>
        );
      default:
        return null;
    }
  };

  const handleTabChange = (newTab) => {
    if (isDirty) {
      const confirmLeave = window.confirm(
        "You have unsaved changes. Do you really want to switch tabs?"
      );
      if (!confirmLeave) return;
    }
    setIsDirty(false)
    setActiveTab(newTab);
  };

  const handleSyncTenantEngineStates = async () => {
    setSyncingEngineStates(true);
    try {
      await api.post('sync/tenant-engine-states');
      toast.success('Tenant engine state sync completed successfully.');
    } catch (error) {
      console.error('Error syncing tenant engine states:', error);
      toast.error(
        error.response?.data?.message || 
        'Error occurred while syncing tenant engine states.'
      );
    } finally {
      setSyncingEngineStates(false);
    }
  };

  const handleSyncTenantStationNames = async () => {
    setSyncingStationNames(true);
    try {
      await api.post('sync/tenant-station-names');
      toast.success('Tenant and station name sync completed successfully.');
    } catch (error) {
      console.error('Error syncing tenant station names:', error);
      toast.error(
        error.response?.data?.message || 
        'Error occurred while syncing tenant and station names.'
      );
    } finally {
      setSyncingStationNames(false);
    }
  };

  return (
   <div className="min-h-screen px-4 py-6 bg-gray-100 dark:bg-gray-900 text-black dark:text-white flex flex-col">
    <Header />

    {/* Main Content */}
    <div className="px-10 pt-11 flex flex-col gap-2.5 flex-1 overflow-hidden">
      <h1 className="text-[18px] font-medium text-gray-800 dark:text-white p-4 border-b-2 border-[#E8E8E8] dark:border-gray-700">
        Master Configuration
      </h1>

      {/* Sync Actions */}
      <div className="flex gap-3 mb-4">
        <button
          onClick={handleSyncTenantEngineStates}
          disabled={syncingEngineStates || syncingStationNames}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            syncingEngineStates || syncingStationNames
              ? 'bg-gray-400 dark:bg-gray-600 text-gray-600 dark:text-gray-400 cursor-not-allowed'
              : 'bg-[#77BEF0BF] dark:bg-blue-600 text-black dark:text-white hover:bg-[#77BEF0] dark:hover:bg-blue-700'
          }`}
        >
          {syncingEngineStates ? 'Syncing...' : 'Sync Tenant Engine States'}
        </button>
        <button
          onClick={handleSyncTenantStationNames}
          disabled={syncingEngineStates || syncingStationNames}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            syncingEngineStates || syncingStationNames
              ? 'bg-gray-400 dark:bg-gray-600 text-gray-600 dark:text-gray-400 cursor-not-allowed'
              : 'bg-[#77BEF0BF] dark:bg-blue-600 text-black dark:text-white hover:bg-[#77BEF0] dark:hover:bg-blue-700'
          }`}
        >
          {syncingStationNames ? 'Syncing...' : 'Sync Tenant Station Names'}
        </button>
      </div>

      {/* Tabs */}
      <div>
        <div className="flex bg-white dark:bg-gray-800 p-4 gap-2 rounded-lg">
          <button 
            className={`p-2 rounded text-sm font-medium transition-colors ${
              activeTab === 'measurement' 
              ? 'text-black dark:text-white bg-[#77BEF0BF] dark:bg-blue-600' 
              : 'border-transparent text-[#4A4A4A] dark:text-gray-300 hover:text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 dark:hover:text-white'
            }`}
            onClick={() => handleTabChange('measurement')}
          >
            Measurement
          </button>
          <button 
            className={`p-2 rounded text-sm font-medium transition-colors ${
              activeTab === 'longlat' 
              ? 'text-black dark:text-white bg-[#77BEF0BF] dark:bg-blue-600' 
              : 'border-transparent text-[#4A4A4A] dark:text-gray-300 hover:text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 dark:hover:text-white'
            }`}
            onClick={() => handleTabChange('longlat')}
          >
            Lat/Long
          </button>
          <button 
            className={`p-2 rounded text-sm font-medium transition-colors ${
              activeTab === 'inclusion' 
              ? 'text-black dark:text-white bg-[#77BEF0BF] dark:bg-blue-600' 
              : 'border-transparent text-[#4A4A4A] dark:text-gray-300 hover:text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 dark:hover:text-white'
            }`}
            onClick={() => handleTabChange('inclusion')}
          >
            Inclusion/Exclusion
          </button>
        </div>
      </div>

      {/* Tab Content */}
      {renderTabContent()}
    </div>
  </div>
  );
};

export default MasterConfiguration;